import type { ReactNode } from 'react';

import { cn } from '../utils/entry.js';

/**
 * Main element to make sure correct padding is applied.
 * https://webkit.org/blog/7929/designing-websites-for-iphone-x/.
 *
 * @param root0 the input object
 * @param root0.children the children to pass down
 * @param root0.className the optional styles to apply/override to the main element
 * @returns main element
 */
export default function Main({ children, className }: { children: ReactNode; className?: string }): ReactNode {
  return <div className={cn('w-full', className)}>{children}</div>;
}
